import { Route, Routes } from 'react-router-dom';

import { ResultPage } from '../pages';

export const PouchResultRoutes = () => {
    return (
        <Routes>
            <Route path="/:id" element={<ResultPage />} />
        </Routes>
    );
};
